import { render, staticRenderFns } from "./testinggdrag.vue?vue&type=template&id=492b0188&scoped=true&"
import script from "./testinggdrag.vue?vue&type=script&lang=js&"
export * from "./testinggdrag.vue?vue&type=script&lang=js&"
import style0 from "./testinggdrag.vue?vue&type=style&index=0&id=492b0188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492b0188",
  null
  
)

/* custom blocks */
import block0 from "./testinggdrag.vue?vue&type=custom&index=0&blockType=html&lang=en"
if (typeof block0 === 'function') block0(component)

export default component.exports